import { hocHook } from "../../../@hoc/hoc-hook";
import { Accelerate } from "./accelerate";

export default hocHook(Accelerate);
